import React from "react";

export default function LoadingData({ text = "Cargando datos..." }) {
  const spinnerStyle = {
    display: "inline-block",
    width: 20,
    height: 20,
    border: "3px solid rgba(0,0,0,0.1)",
    borderTopColor: "#3498db",
    borderRadius: "50%",
    animation: "lds-spin 1s linear infinite",
    marginRight: 8,
  };

  const wrapper = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#333",
    fontSize: 14,
    padding: "6px 8px",
  };

  return (
    <div style={wrapper}>
      <span style={spinnerStyle} />
      <span>{text}</span>

      <style>{`
        @keyframes lds-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
